const ImageDimensionalLogo = ({ themeChoice }) => {
	const themes = {
		white: {
			st0Color: "#fff",
			st1Color: "#fff"
		},
		colored: {
			st0Color: "#AB2422",
			st1Color: "#4D4D4F"
		}
	};

	const theme = themes[themeChoice];

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 115.23 26.4"
			width="145px"
			height="42px"
		>
			<desc> {`Dimensional's ${themeChoice} logo`} </desc>
			<g>
				<path
					className="cls-2"
					style={{ fill: theme.st0Color, strokeWidth: "0px" }}
					d="M15.61,15.32c-.02-.14-.18-.23-.18-.23l-1.75-1.04c-.46.27-9.42,5.45-10.22,5.85-.19.1-.36.15-.5.15s-.25-.05-.34-.14c-.17-.17-.19-.45-.19-.56v-.03s0-18.72,0-18.72c-.29.15-1.23.66-1.81,1.07C-.03,2.13,0,3.05,0,3.06,0,3.24,0,21.74,0,23.23c0,.31.06.52.19.64.09.09.21.13.36.13.33,0,.69-.22.69-.22.14-.08,13.84-7.86,14.22-8.19.11-.09.16-.18.15-.28Z"
				/>
				<path
					className="cls-2"
					style={{ fill: theme.st0Color, strokeWidth: "0px" }}
					d="M21.55,14.24c-.13-.07-12.92-7.56-13.39-7.73-.07-.03-.13-.04-.19-.04-.08,0-.13.02-.18.07-.09.1-.08.28-.08.28v2.01c.45.27,9.41,5.45,10.18,5.91.31.18.46.38.46.59,0,.35-.43.59-.46.6L1.67,25.26c.24.14,1.25.72,1.91,1.02.18.08.37.12.57.12.5,0,.89-.25.9-.26.16-.09,15.2-8.78,16.49-9.52.65-.38.97-.77.97-1.18,0-.69-.94-1.2-.95-1.21Z"
				/>
				<path
					className="cls-2"
					style={{ fill: theme.st0Color, strokeWidth: "0px" }}
					d="M3.92,17.34c0,.23.08.33.22.33s.31-.1.31-.1l1.77-.91s0-10.72,0-11.74c0-.34.07-.59.21-.73.08-.09.2-.13.34-.13.27,0,.53.16.54.17l15.14,8.75c0-.24-.03-1.15-.05-1.89-.03-.84-.36-1.19-1-1.6-.15-.08-14.93-8.56-16.23-9.28-.26-.14-.48-.21-.66-.21-.15,0-.28.05-.37.15-.24.24-.22.71-.22.71v16.48Z"
				/>
			</g>
			<g>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M60.43,9.36c-2.37,0-3.58,1.36-3.58,4.04v3.7c0,2.28,1.3,3.64,3.48,3.64s3.62-1.31,3.62-3.42v-.54l-2.07.42c0,1.61-.91,1.85-1.45,1.85-.95,0-1.43-.62-1.43-1.84v-1.84h4.98v-2c0-1.27-.11-1.83-.51-2.49-.59-.97-1.68-1.51-3.05-1.51ZM61.83,13.61v.16h-2.83v-.83c0-1.22.48-1.84,1.43-1.84.64,0,1.4.32,1.4,1.84v.67Z"
				/>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M111.02,12.25c0-1.8-1.21-2.97-3.09-2.97-2.34,0-3.77,1.29-3.85,3.45v.03h0v.33l2.06-.35c.15-1.09.64-1.64,1.46-1.64s1.2.54,1.2,1.62v.54l-.09.04-.89.41c-.87.4-1.63.82-2.09,1.15-1.26.91-1.87,2-1.87,3.33,0,1.54.93,2.54,2.37,2.54,1.07,0,1.67-.3,2.37-1.17l.25-.31.03.4.07.9h2.24c-.14-.9-.17-1.2-.17-1.64v-6.66ZM108.8,15.09v2.89l-.04.04c-.72.79-1.02.96-1.63.96-.66,0-1.05-.44-1.05-1.19,0-1.07.75-1.92,2.49-2.85l.23-.12v.26Z"
				/>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M32.84,5.74h-3.46v14.81h3.46c1.42,0,2.41-.34,3.09-1.06.68-.72,1.09-1.95,1.09-3.29v-6.09c0-1.39-.41-2.6-1.12-3.33-.7-.72-1.64-1.04-3.05-1.04ZM34.62,16.35c0,1.71-.52,2.26-2.15,2.26h-.68V7.65h.68c1.59,0,2.15.6,2.15,2.3v6.41Z"
				/>
				<g>
					<polygon
						className="cls-1"
						style={{ fill: theme.st1Color, strokeWidth: "0px" }}
						points="41.38 5.58 39.22 5.58 39.22 6.01 39.22 7.07 39.22 7.67 41.38 7.67 41.38 7.15 41.38 6.17 41.38 5.58"
					/>
					<polygon
						className="cls-1"
						style={{ fill: theme.st1Color, strokeWidth: "0px" }}
						points="41.38 9.51 39.22 9.51 39.22 12.65 39.22 17.38 39.22 20.55 41.38 20.55 41.38 17.38 41.38 12.56 41.38 9.51"
					/>
				</g>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M53.1,9.36c-.88,0-1.5.31-2.51,1.23l-.13.12-.1-.15c-.69-1.02-.95-1.2-1.78-1.2s-1.36.27-2.39,1.17l-.26.23v-1.24h-2.15v11.04h2.15v-8.67l.06-.05c.69-.49,1.07-.66,1.5-.66.32,0,.85.15.85,1.13v8.25h2.16v-8.67l.06-.05c.63-.47,1.08-.68,1.48-.68s.87.2.87,1.15v8.25h2.16v-8.88c0-1.06-.34-2.31-1.96-2.31Z"
				/>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M70.69,9.36c-.8,0-1.44.29-2.33,1.09l-.26.23v-1.16h-2.16v11.04h2.16v-8.67l.07-.05c.76-.51,1.11-.66,1.47-.66.55,0,.89.43.89,1.13v8.25h2.14v-8.88c0-1.54-.67-2.31-1.98-2.31Z"
				/>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M78.13,13.95c-1.21-.9-1.61-1.29-1.61-1.87s.46-1.05,1.05-1.05c.66,0,1.12.48,1.31,1.35l1.88-.17c-.37-1.93-1.46-2.9-3.23-2.9s-3.11,1.24-3.11,2.88c0,1.33.72,2.3,2.74,3.69,1.21.85,1.57,1.3,1.57,1.93s-.48,1.1-1.14,1.1c-.92,0-1.23-.45-1.54-1.71l-1.86.48c.41,2.08,1.52,3.05,3.5,3.05,1.83,0,3.16-1.28,3.16-3.03,0-1.41-.53-2.15-2.72-3.77Z"
				/>
				<g>
					<polygon
						className="cls-1"
						style={{ fill: theme.st1Color, strokeWidth: "0px" }}
						points="84.79 9.51 82.63 9.51 82.63 11.34 82.63 17.03 82.63 20.55 84.79 20.55 84.79 17.03 84.79 11.16 84.79 9.51"
					/>
					<polygon
						className="cls-1"
						style={{ fill: theme.st1Color, strokeWidth: "0px" }}
						points="84.79 5.58 82.63 5.58 82.63 6.17 82.63 7.15 82.63 7.67 84.79 7.67 84.79 7.15 84.79 6.26 84.79 5.58"
					/>
				</g>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M90.2,9.32c-2.24,0-3.58,1.47-3.58,3.94v3.56c0,2.48,1.33,3.96,3.56,3.96s3.58-1.48,3.58-3.96v-3.56c0-2.47-1.33-3.94-3.56-3.94ZM91.54,17.09c0,1.25-.46,1.88-1.36,1.88-.61,0-1.35-.33-1.35-1.88v-4.11c0-1.23.46-1.86,1.38-1.86s1.32.63,1.32,1.86v4.11Z"
				/>
				<path
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					d="M100.14,9.36c-.8,0-1.43.29-2.32,1.09l-.26.23v-1.16h-2.16v11.04h2.16v-8.67l.07-.05c.75-.5,1.1-.66,1.47-.66.55,0,.89.43.89,1.13v8.25h2.14v-8.88c0-1.54-.66-2.31-1.98-2.31Z"
				/>
				<polygon
					className="cls-1"
					style={{ fill: theme.st1Color, strokeWidth: "0px" }}
					points="113.23 20.55 115.23 20.55 115.23 17.21 115.23 9.41 115.23 5.74 113.23 5.74 113.23 9.58 113.23 16.94 113.23 20.55"
				/>
			</g>
		</svg>
	);
};

export default ImageDimensionalLogo;
